import en from "./en.json";

export default {
  en,
};